/*eslint react-hooks/exhaustive-deps: "off"*/
import React, { useCallback, useContext, useRef, useState } from "react";
import { Form, Checkbox, Row, Col } from "antd";
import { Title } from "./Common";
import MapPropsContext from "../MapPropsContext";
import { TI_SELECT_ALL_CHECK_BOX } from "../../../Constants";
import StyledCheckBox from "../../../styled-components/StyledChekbox";
import StyledCheckBoxWithLabel from "../../../styled-components/StyledCheckboxWithLabel";

export const OPTIONS = [
  //  {value: "05,06", label: "2G", iconCode: '2g-out'},
  { value: "15", label: "3G", iconCode: "3g-orange-out" },
  { value: "18,19", label: "4G", iconCode: "4g-blue-out" },
  { value: "43,45", label: "5G", iconCode: "5g-yellow-out" },
];

function WidgetServiceCode() {
  const { widgetState, onChangeWidgetState, iconDict } =
    useContext(MapPropsContext);
  const { service_code_list } = widgetState;
  const [state, setState] = useState({
    indeterminate: service_code_list.length < OPTIONS.length,
    checkAll: service_code_list.length === OPTIONS.length,
  });

  const onCheckAllChange = useCallback(({ target: { checked } }) => {
    setState({
      indeterminate: false,
      checkAll: checked,
    });
    onChangeWidgetState({
      target: {
        name: "service_code_list",
        value: !checked ? [] : OPTIONS.map(({ value }) => value),
      },
    });
  }, []);

  const onChange = useCallback(
    (checkedValues) => {
      setState({
        indeterminate:
          !!checkedValues.length && checkedValues.length < OPTIONS.length,
        checkAll: checkedValues.length === OPTIONS.length,
      });

      onChangeWidgetState({
        target: {
          name: "service_code_list",
          value: checkedValues,
        },
      });
    },
    [onChangeWidgetState, setState]
  );

  const { indeterminate, checkAll } = state;

  return (
    <Form.Item>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <Title>서비스</Title>
        <label>
          <StyledCheckBox
            checked={checkAll}
            onChange={onCheckAllChange}
            tabIndex={TI_SELECT_ALL_CHECK_BOX}
          />
          <span style={{ marginLeft: 8 }}>전체 선택</span>
        </label>
      </div>
      {/* <Checkbox.Group
        name="service_code_list"
        value={service_code_list}
        onChange={onChange}
        size={"small"}
        style={{ width: "100%" }}
      > */}
      <div>
        {OPTIONS.map(({ value, label, iconCode }, index) => {
          const { data, width, height } = iconDict[iconCode] || {};
          const iconWidth = 24;
          const ratio = iconWidth / width;
          const iconHeight = Math.floor(height * ratio);
          return (
            <Col span={8} key={value}>
              <label>
                <StyledCheckBox
                  checked={service_code_list.includes(value)}
                  onChange={() => {
                    // console.log(widgetState,/ fieldValue);
                    let checkedValues = [...service_code_list];
                    const findIndex = service_code_list.indexOf(value);
                    if (findIndex === -1) {
                      checkedValues.push(value);
                    } else {
                      checkedValues = checkedValues.filter(
                        (checkedValue) => checkedValue !== value
                      );
                    }
                    onChange(checkedValues);
                  }}
                  tabIndex={TI_SELECT_ALL_CHECK_BOX + 1 + index}
                />
                <span style={{ marginLeft: 8 }}>
                  {" "}
                  {/*data && (
                    <img
                      src={data}
                      style={{
                        width: iconWidth,
                        height: iconHeight,
                        marginRight: 4,
                      }}
                      alt={""}
                    />
                  )*/}
                  {label}
                </span>
              </label>
              {/* <Checkbox
                  value={value}
                  key={label}
                  tabIndex={TI_SELECT_ALL_CHECK_BOX + 1 + index}
                >
                  {data && (
                    <img
                      src={data}
                      style={{
                        width: iconWidth,
                        height: iconHeight,
                        marginRight: 4,
                      }}
                      alt={""}
                    />
                  )}
                  {label}
                </Checkbox> */}
            </Col>
          );
        })}
      </div>
      {/* </Checkbox.Group> */}
      <br />
    </Form.Item>
  );
}

export default WidgetServiceCode;
